import React from "react";

const Projects = ({
  active,
  width = 20,
  height = 20,
}: {
  active: boolean;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 2.5H15.2537C16.0802 2.5 16.75 3.1735 16.75 3.9925V16.0075C16.75 16.8317 16.0802 17.5 15.2537 17.5H3.25V2.5ZM6.25 4H4.75V16H6.25V4ZM7.75 16H15.25V4H7.75V16ZM9.25 13C9.25 12.4033 9.48705 11.831 9.90901 11.409C10.331 10.9871 10.9033 10.75 11.5 10.75C12.0967 10.75 12.669 10.9871 13.091 11.409C13.5129 11.831 13.75 12.4033 13.75 13H9.25ZM11.5 10C11.1022 10 10.7206 9.84196 10.4393 9.56066C10.158 9.27936 10 8.89782 10 8.5C10 8.10218 10.158 7.72064 10.4393 7.43934C10.7206 7.15804 11.1022 7 11.5 7C11.8978 7 12.2794 7.15804 12.5607 7.43934C12.842 7.72064 13 8.10218 13 8.5C13 8.89782 12.842 9.27936 12.5607 9.56066C12.2794 9.84196 11.8978 10 11.5 10ZM17.5 5.5H19V8.5H17.5V5.5ZM17.5 10H19V13H17.5V10Z"
        fill={` ${active ? "#2D96A7" : "#868C98"} `}
      />
    </svg>
  );
};

export default Projects;
